import createIcon from '../../createIcon';

/**
 * @component @name Liquor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDE0QzIuNSAxNS4zIDMuMzQgMTYuNCA0LjUgMTYuODJWMjBIMi41VjIySDguNVYyMEg2LjVWMTYuODJDNy42NiAxNi40IDguNSAxNS4zIDguNSAxNFY2SDIuNVYxNFpNNC41IDhINi41VjExSDQuNVY4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwLjEzIDguNTRMMTkuMTggOC4yMkMxOC43OCA4LjA5IDE4LjUgNy43MSAxOC41IDcuMjhWM0MxOC41IDIuNDUgMTguMDUgMiAxNy41IDJIMTQuNUMxMy45NSAyIDEzLjUgMi40NSAxMy41IDNWNy4yOEMxMy41IDcuNzEgMTMuMjIgOC4wOSAxMi44MiA4LjIzTDExLjg3IDguNTVDMTEuMDUgOC44MiAxMC41IDkuNTggMTAuNSAxMC40NFYyMEMxMC41IDIxLjEgMTEuNCAyMiAxMi41IDIySDE5LjVDMjAuNiAyMiAyMS41IDIxLjEgMjEuNSAyMFYxMC40NEMyMS41IDkuNTggMjAuOTUgOC44MiAyMC4xMyA4LjU0Wk0xNS41IDRIMTYuNVY1SDE1LjVWNFpNMTIuNSAxMC40NEwxMy40NSAxMC4xMkMxNC42OCA5LjcyIDE1LjUgOC41NyAxNS41IDcuMjhWN0gxNi41VjcuMjhDMTYuNSA4LjU3IDE3LjMyIDkuNzIgMTguNTUgMTAuMTNMMTkuNSAxMC40NFYxMkgxMi41VjEwLjQ0Wk0xOS41IDIwSDEyLjVWMThIMTkuNVYyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Liquor = createIcon('Liquor', [
  [
    'path',
    {
      d: 'M2.5 14C2.5 15.3 3.34 16.4 4.5 16.82V20H2.5V22H8.5V20H6.5V16.82C7.66 16.4 8.5 15.3 8.5 14V6H2.5V14ZM4.5 8H6.5V11H4.5V8Z',
      key: '1swjmh',
    },
  ],
  [
    'path',
    {
      d: 'M20.13 8.54L19.18 8.22C18.78 8.09 18.5 7.71 18.5 7.28V3C18.5 2.45 18.05 2 17.5 2H14.5C13.95 2 13.5 2.45 13.5 3V7.28C13.5 7.71 13.22 8.09 12.82 8.23L11.87 8.55C11.05 8.82 10.5 9.58 10.5 10.44V20C10.5 21.1 11.4 22 12.5 22H19.5C20.6 22 21.5 21.1 21.5 20V10.44C21.5 9.58 20.95 8.82 20.13 8.54ZM15.5 4H16.5V5H15.5V4ZM12.5 10.44L13.45 10.12C14.68 9.72 15.5 8.57 15.5 7.28V7H16.5V7.28C16.5 8.57 17.32 9.72 18.55 10.13L19.5 10.44V12H12.5V10.44ZM19.5 20H12.5V18H19.5V20Z',
      key: '1lzkn8',
    },
  ],
]);

export default Liquor;
